/**
 * Created by olga on 03.07.2025
 */

const Merge2TutorialHelper = {
    createReplaceOrderStep: function (data) {
        return new TutorialStep({
            onStart: function () {
                const customers = Merge2.current.customers;

                const customer = customers.list().find((customer) => customer.customerIndex === data.customerIndex);
                customers.createCustomOrder(customer, data.recipe);

                this.finish();
            },

            onFinish: function () {
                Merge2.current.counter.trigger();
            }
        });
    },

    createClickRowStep: function (data) {
        return new TutorialStep({
            onStart: function () {
                cleverapps.focusManager.showControlsWhileFocused(Merge2.current.getUpContainerControls());
                const rowId = data.rowId;

                const ordersTable = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).ordersTable;

                let actionPlayer;
                const showForce = () => {
                    if (actionPlayer) {
                        actionPlayer.stop();
                    }

                    actionPlayer = new ActionPlayer([
                        (f) => {
                            if (cleverapps.forces.isRunningForce()) {
                                cleverapps.forces.closeRunningForce();
                            }

                            ordersTable.scrollToRow(rowId, f);
                        },

                        (f) => {
                            if (cleverapps.focusManager.currentWindow()) {
                                f();

                                return;
                            }

                            const rowView = Merge2TutorialHelper.findOfferRowView(rowId);

                            const force = data.force;
                            const tapTarget = ComponentUtils.findChildrenByTag(rowView, "tapTarget")[0];
                            if (tapTarget) {
                                force.finger = { tap: tapTarget };
                            }

                            const mapView = Merge2.current.field.getMapView();
                            this.force = Merge2TutorialHelper.createForce(rowView, force || {}, {
                                highlights: [cleverapps.Scenes.GetMovingNode(rowView), mapView.animations]
                            });

                            f();
                        }
                    ]);

                    actionPlayer.play();
                };

                showForce();

                cleverapps.tutorial.on("onResize", showForce, this);
                cleverapps.tutorial.on("window_closed", showForce, this);
                cleverapps.tutorial.on("addRowView", (id) => {
                    if (id === rowId) {
                        showForce();
                    }
                }, this);

                cleverapps.tutorial.on(data.finishEvent, (options) => {
                    if (!data.finishFilter || data.finishFilter(options)) {
                        this.finish();
                    }
                }, this);
            },

            onFinish: function () {
                this.force && this.force.hideForceHints();
                Merge2.current.counter.trigger();
            }
        });
    },

    scrollToExtraBarRow: function (rowId, cb) {
        const extraBarTable = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).extraBarTable;

        if (!extraBarTable || !extraBarTable.rows.find((row) => row.id === rowId)) {
            cb();
            return;
        }

        extraBarTable.scrollToRow(rowId, cb);
    },

    createWaitRowStep: function (rowId) {
        return new TutorialStep({
            onStart: function () {
                cleverapps.focusManager.showControlsWhileFocused(Merge2.current.getUpContainerControls());
                const rowView = Merge2TutorialHelper.findOfferRowView(rowId);
                if (rowView) {
                    this.finish();
                    return;
                }

                cleverapps.tutorial.on("addRowView", (id) => {
                    if (id === rowId) {
                        this.finish();
                    }
                }, this);
            },

            onFinish: function () {
                Merge2.current.counter.trigger();
            }
        });
    },

    createClickUnitStep: function (data) {
        return new TutorialStep({
            onCheckConditions: function (options) {
                return Unit.Equals(options.unit, this.unit);
            },

            onStart: function () {
                cleverapps.focusManager.showControlsWhileFocused(Merge2.current.getUpContainerControls());
                const finishEvent = data.finishEvent || Field.CLICK_UNIT;

                if (finishEvent === "onUnitSpawned" && !Merge2.current.field.findEmptySlot(0, 0)) {
                    this.finish();
                    return;
                }

                this.count = data.count;

                this.unit = Merge2.current.field.listAvailableUnits(data.filter || data.unit).filter((unit) => !unit.isGrounded())[0];

                if (!this.unit) {
                    this.finish();
                    return;
                }

                if (data.forceDrop) {
                    const generator = this.unit.findComponent(Merge2Generator);
                    if (generator && generator.data.drop.includes(data.forceDrop)) {
                        const originalData = generator.data;
                        generator.data = { ...originalData, drop: [data.forceDrop], weights: [1] };
                        this.restoreForcedDrop = () => {
                            generator.data = originalData;
                        };
                    }
                }

                const forceConfig = { ...data.force || {} };
                if (forceConfig.id) {
                    cleverapps.forces.saveForce(forceConfig);
                    delete forceConfig.id;
                }

                const createForce = () => {
                    if (this.force) {
                        return;
                    }

                    let forceOptions;
                    if (data.highlightedCells) {
                        this.highlightedCells = Array.isArray(data.highlightedCells) ? data.highlightedCells : [{ x: this.unit.x, y: this.unit.y }];
                        forceOptions = Merge2TutorialHelper.getHighlightCellsOptions(this.highlightedCells);

                        cleverapps.tutorial.on("onUnitSpawned", (unit) => {
                            const unitView = unit.onGetView();
                            if (!unitView || !this.force) {
                                return;
                            }

                            this.force.highlights.push(unitView);
                            this.force.addActive(unitView);
                            this.force.upNodesForForce();
                        }, this);
                    } else {
                        forceOptions = {
                            highlightActives: false,
                            importantNodes: [this.unit.onGetView()]
                        };
                    }

                    forceOptions.actives = this.highlightedCells ? Merge2TutorialHelper.getCellsUnitViews(this.highlightedCells) : [Merge2.current.field.getMapView()];

                    forceConfig.shadow = this.highlightedCells || false;
                    forceConfig.text = forceConfig.text || data.text;
                    forceConfig.finger = { ...forceConfig.finger, tap: this.unit.onGetView() };
                    forceConfig.minimal = {
                        delay: data.delay || 0
                    };
                    forceConfig.position = data.position;
                    this.force = Merge2TutorialHelper.createForce(this.unit.onGetView(), forceConfig, forceOptions);
                };
                createForce();

                cleverapps.tutorial.on("window_closed", () => {
                    if (!cleverapps.focusManager.currentWindow()) {
                        createForce();
                    }
                }, this);

                const finishFilter = data.finishFilter || function (unit) {
                    return Unit.Equals(this.unit, unit);
                }.bind(this);
                cleverapps.tutorial.on(finishEvent, (unit) => {
                    if (finishEvent === "onUnitSpawned" && !Merge2.current.field.findEmptySlot(0, 0)) {
                        this.finish();
                        return;
                    }

                    if (finishFilter(unit)) {
                        if (this.count) {
                            this.count--;
                            if (this.count <= 0) {
                                this.finish();
                            }
                            return;
                        }
                        this.finish();
                    }
                }, this);

                cleverapps.tutorial.on("onResize", () => {
                    if (this.isFinished()) {
                        return;
                    }
                    if (cleverapps.forces.isRunningForce()) {
                        cleverapps.forces.closeRunningForce();
                    }
                    delete this.force;
                    if (!cleverapps.focusManager.currentWindow()) {
                        createForce();
                    }
                }, this);
            },

            onFinish: function () {
                this.restoreForcedDrop && this.restoreForcedDrop();
                this.force && this.force.hideForceHints();
                Merge2.current.counter.trigger();
            }
        });
    },

    getPositionAboveMap: function () {
        return (dialogue) => {
            const mapView = Merge2.current.field.getMapView();
            const mapRect = mapView.getSceneBoundingBox();
            const sceneSize = cleverapps.resolution.getSceneSize();
            const halfWidth = dialogue.width * dialogue.scaleX / 2;
            const padding = cc.padding(cleverapps.styles.MinimalDialogue.padding);
            const x = cc.clampf(mapRect.x + mapRect.width / 2, halfWidth + padding.left, sceneSize.width - halfWidth - padding.right);
            return cc.p(
                x,
                mapRect.y + mapRect.height - dialogue.height * dialogue.scaleY / 2 - cleverapps.styles.Merge2TutorialHelper.PositionAboveMap.topOffset
            );
        };
    },

    getHighlightCellsOptions: function (highlightedCells) {
        const mapView = Merge2.current.field.getMapView();
        const highlights = [mapView.animations, cleverapps.Scenes.GetMovingNode()];
        const importantNodes = [];
        highlightedCells.forEach((cell) => {
            const unit = Merge2.current.field.getUnit(cell.x, cell.y);
            const unitView = unit && unit.onGetView();
            if (unitView) {
                const grounded = unit.findComponent(Grounded);
                if (grounded && grounded.isOpened() && cleverapps.styles.GroundedView.openedZOrder < 0) {
                    highlights.push(grounded.view.spine, grounded.view.bg);
                }
                highlights.push(unitView);
            }
            const tile = mapView.getTileView(cell.x, cell.y);
            highlights.push(tile);
            importantNodes.push(tile);
        });
        return {
            highlightActives: false,
            importantNodes,
            highlights
        };
    },

    getCellsUnitViews: function (cells) {
        return cells.map((cell) => {
            const unit = Merge2.current.field.getUnit(cell.x, cell.y);
            return unit && unit.onGetView();
        }).filter(Boolean);
    },

    getHighlightCells: function (units) {
        const minY = Math.min(units[0].y, units[1].y);
        const maxY = Math.max(units[0].y, units[1].y);
        const minX = Math.min(units[0].x, units[1].x);
        const maxX = Math.max(units[0].x, units[1].x);

        const cells = [];

        for (let y = minY; y <= maxY; y++) {
            for (let x = minX; x <= maxX; x++) {
                cells.push({ y, x });
            }
        }

        return cells;
    },

    createMergeStep: function (data) {
        const options = {
            onCheckConditions: function (options) {
                if (options.cell && this.highlightedCells
                    && !this.highlightedCells.some((cell) => options.cell.x === cell.x && options.cell.y === cell.y)) {
                    return false;
                }

                return true;
            },

            onStart: function () {
                cleverapps.focusManager.showControlsWhileFocused(Merge2.current.getUpContainerControls());
                const units = Merge2.current.field.listAvailableUnits(data.unit);

                if (units.length < 2) {
                    this.finish();
                    Merge2.current.counter.trigger();
                    return;
                }

                const groundedUnits = units.filter((unit) => unit.isGrounded());
                const notGroundedUnits = units.filter((unit) => !unit.isGrounded());
                this.units = data.noGroundedFirst
                    ? [notGroundedUnits[0] || groundedUnits[0], notGroundedUnits[1] || groundedUnits[1]]
                    : [notGroundedUnits[0], groundedUnits[0] || notGroundedUnits[1]];
                
                const createForce = () => {
                    if (this.force) {
                        return;
                    }

                    const mapView = Merge2.current.field.getMapView();
                    const unitViews = this.units.map((unit) => unit.onGetView()).filter(Boolean);

                    let forceOptions = {};
                    if (data.highlightedCells) {
                        this.highlightedCells = Array.isArray(data.highlightedCells) ? data.highlightedCells : Merge2TutorialHelper.getHighlightCells(this.units);
                        forceOptions = Merge2TutorialHelper.getHighlightCellsOptions(this.highlightedCells);

                        cleverapps.tutorial.on("onUnitAvailable", (unit) => {
                            const unitView = unit.onGetView();
                            if (!unitView || !this.force) {
                                return;
                            }

                            if (this.highlightedCells.some((cell) => cell.x === unit.x && cell.y === unit.y)) {
                                this.force.highlights.push(unitView);
                                this.force.addActive(unitView);
                                this.force.upNodesForForce();
                            }
                        }, this);
                    }

                    const ordersTable = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).ordersTable;

                    forceOptions.importantNodes = forceOptions.importantNodes || [];
                    forceOptions.importantNodes = forceOptions.importantNodes.concat(ordersTable.rows.map((row) => ordersTable.getRowView(row.id)));

                    forceOptions.actives = this.highlightedCells ? Merge2TutorialHelper.getCellsUnitViews(this.highlightedCells) : [mapView];

                    this.force = Merge2TutorialHelper.createForce(unitViews[0], {
                        text: data.text,
                        position: data.position,
                        shadow: data.highlightedCells || false,
                        finger: unitViews.length > 1 && {
                            swipe: unitViews
                        }
                    }, forceOptions);
                };
                createForce();

                const unit = this.units[0];
                const mergeComponent = unit.findComponent(MergeComponent);

                const cells = this.units.map((unit) => cc.p(unit.x, unit.y));

                mergeComponent.highlightMergeHint(cells);

                const stopHint = () => {
                    if (this.saveTimeout) {
                        cleverapps.timeouts.clearTimeout(this.saveTimeout);
                        this.saveTimeout = undefined;
                    }

                    mergeComponent.unhighlightUnits();
                    this.force && this.force.stopFinger();
                };

                const startHint = () => {
                    this.saveTimeout = cleverapps.timeouts.setTimeout(() => {
                        const cells = this.units.map((unit) => cc.p(unit.x, unit.y));
                        mergeComponent.highlightMergeHint(cells);
                        this.force && this.force.resumeFinger();
                    }, 500);
                };

                cleverapps.tutorial.on("window_closed", () => {
                    if (!cleverapps.focusManager.currentWindow()) {
                        createForce();
                    }
                }, this);

                Merge2.current.field.on("changeDragging", (unit) => {
                    if (unit) {
                        stopHint();
                    } else {
                        startHint();
                    }
                }, this);

                Merge2.current.field.on("unitSelectionChanged", () => {
                    stopHint();
                    startHint();
                }, this);

                cleverapps.tutorial.on("onResize", () => {
                    if (cleverapps.forces.isRunningForce()) {
                        cleverapps.forces.closeRunningForce();
                    }
                    delete this.force;

                    if (!cleverapps.focusManager.currentWindow()) {
                        createForce();
                    }
                    if (!Merge2.current.field.dragging) {
                        mergeComponent.highlightMergeHint(cells);
                    }
                }, this);

                cleverapps.tutorial.on("merge", (affectedUnits) => {
                    if (affectedUnits.find((affected) => Unit.Equals(unit, affected))) {
                        this.finish();
                        Merge2.current.counter.trigger();
                    }
                }, this);
            },

            onFinish: function () {
                if (this.saveTimeout) {
                    cleverapps.timeouts.clearTimeout(this.saveTimeout);
                    this.saveTimeout = undefined;
                }
                this.force && this.force.hideForceHints();
            }
        };

        return new TutorialStep(options);
    },

    createBubbleStackStep: function (data) {
        return new TutorialStep({
            onStart: function () {
                cleverapps.focusManager.showControlsWhileFocused(Merge2.current.getUpContainerControls());
                let isVertical = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL;

                const ordersTable = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).ordersTable;

                const mapView = Merge2.current.field.getMapView();
                const highlights = [mapView.animations, cleverapps.Scenes.GetMovingNode()];

                const showVertical = () => {
                    const rowView = Merge2TutorialHelper.findOfferRowView(BubblesStack.ID);
                    const force = { text: data.text };
                    if (rowView.getPositionForFinger) {
                        force.finger = { tap: rowView.getPositionForFinger() };
                    }

                    const mapView = Merge2.current.field.getMapView();

                    ordersTable.scrollToRow(BubblesStack.ID, () => {
                        this.force = Merge2TutorialHelper.createForce(rowView, force || {}, {
                            highlights: [cleverapps.Scenes.GetMovingNode(rowView), mapView.animations]
                        });
                    });
                };

                const showHorizontal = () => {
                    Merge2TutorialHelper.scrollToExtraBarRow(
                        Merge2.current.bubblesStack.index,
                        () => {
                            this.force = Merge2TutorialHelper.createForce(Merge2.current.bubblesStack.onGetView(), {
                                text: data.text
                            }, { highlights });
                        }
                    );
                };

                const onResize = () => {
                    const isVerticalNew = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL;
                    if (isVertical === isVerticalNew) {
                        return;
                    }
                    
                    isVertical = isVerticalNew;

                    if (cleverapps.forces.isRunningForce()) {
                        cleverapps.forces.closeRunningForce();
                    }
                    delete this.force;

                    cleverapps.timeouts.clearTimeout(this.forceTimeout);
                    cleverapps.timeouts.clearTimeout(this.resizeTimeout);

                    this.resizeTimeout = cleverapps.timeouts.setTimeout(() => {
                        if (isVertical) {
                            showVertical();
                        } else {
                            showHorizontal();
                        }
                    }, 300);
                };

                if (isVertical) {
                    showVertical();
                } else {
                    showHorizontal();
                }

                const finishFilter = (unit) => !unit || data.unit.code === unit.code;

                cleverapps.tutorial.on("onPopBubbleStack", (unit) => {
                    if (finishFilter(unit)) {
                        this.finish();
                    }
                }, this);
                cleverapps.tutorial.on("onResize", onResize, this);
            },

            onFinish: function () {
                cleverapps.timeouts.clearTimeout(this.forceTimeout);
                cleverapps.timeouts.clearTimeout(this.resizeTimeout);

                this.force && this.force.hideForceHints();
                Merge2.current.counter.trigger();
            }
        });
    },

    createSwitchStep: function (step) {
        step = step || {};

        const options = {
            onStart: function () {
                if (Merge2.current.mode === step.mode) {
                    this.finish();
                    return;
                }

                const switchButton = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).switchButton;

                const createForce = () => {
                    this.force = Merge2TutorialHelper.createForce(switchButton, {
                        finger: step.finger,
                        text: step.text
                    });
                };
                createForce();

                cleverapps.tutorial.on("switchButton", this.finish.bind(this), this);
            },

            onFinish: function () {
                this.force && this.force.hideForceHints();
                Merge2.current.counter.trigger(step.delay);
            }
        };

        return new TutorialStep(options);
    },

    createAnimationStep: function (step) {
        return new TutorialStep({
            onStart: function () {
                step.animation.show(this.finish.bind(this));
            },

            onFinish: function () {
                Merge2.current.counter.trigger();
            }
        });
    },

    createRepairStep: function () {
        const options = {
            onStart: function () {
                cleverapps.focusManager.showControlsWhileFocused(Merge2.current.getUpContainerControls());

                const window = cleverapps.focusManager.currentWindow();
                if (!window) {
                    this.finish();
                    return;
                }
                const scene = cleverapps.Scenes.GetRunningScene();

                this.force = Merge2TutorialHelper.createForce(window.button, {
                    disableFallbackTimeout: true
                }, {
                    highlights: [window, cleverapps.Scenes.GetMovingNode(window), ComponentUtils.findComponentByName(scene, "UpMenuController").getMenuBar()]
                });

                cleverapps.tutorial.on("locationNextStage", () => {
                    this.finish();
                }, this);
            },

            onFinish: function () {
                Merge2.current.counter.trigger();
            }
        };

        return new TutorialStep(options);
    },

    createOpenTaskWindowStep: function (step) {
        if (Merge2.current.mode === Merge2.MODE_GAME) {
            return Merge2TutorialHelper.createClickRowStep({
                rowId: "new_task",
                finishEvent: "window_shown",
                finishFilter: (options) => options.windowName === "NewTaskWindow",
                force: {
                    text: step.text,
                    gravitate: MinimalDialogue.GRAVITATE.BOTTOM
                }
            });
        }

        const options = {
            onStart: function () {
                cleverapps.focusManager.showControlsWhileFocused(Merge2.current.getUpContainerControls());
                const repairView = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).roomView.getRepairView();

                this.force = Merge2TutorialHelper.createForce(repairView, {
                    text: step.text,
                    disableFallbackTimeout: true
                });

                cleverapps.tutorial.on("window_shown", () => this.finish(), this);
            },

            onFinish: function () {
                Merge2.current.counter.trigger();
            }
        };

        return new TutorialStep(options);
    },

    createFreeFixStep: function () {
        return new TutorialStep({
            onStart: function () {
                cleverapps.focusManager.showControlsWhileFocused(Merge2.current.getUpContainerControls());
                const repairView = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).roomView.getRepairView();

                this.force = Merge2TutorialHelper.createForce(repairView, {
                    shadow: false,
                    disableFallbackTimeout: true
                });

                cleverapps.tutorial.on("roomRepairFinish", () => this.finish(), this);
            },

            onFinish: function () {
                Merge2.current.counter.trigger();
            }
        });
    },

    createCompleteRepairAnimationStep: function () {
        const options = {
            onStart: function () {
                cleverapps.focusManager.showControlsWhileFocused(Merge2.current.getUpContainerControls());
                this.force = Merge2TutorialHelper.createForce(cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).switchButton, {
                    finger: false,
                    shadow: false
                });

                cleverapps.tutorial.on("roomRepairFinish", () => {
                    this.finish();
                }, this);
            },

            onFinish: function () {
                Merge2.current.counter.trigger();
            }
        };

        return new TutorialStep(options);
    },

    createMinimalDialogueStep: function (step) {
        const options = {
            onStart: function () {
                cleverapps.focusManager.showControlsWhileFocused(Merge2.current.getUpContainerControls());
                const createForce = () => {
                    this.force = Merge2TutorialHelper.createForce(ForceView.NO_ELEMENT, {
                        text: step.text,
                        position: step.position || MinimalDialogue.POSITIONS.CENTER,
                        okButton: true
                    });
                };

                createForce();

                cleverapps.tutorial.on("touchInShadow", this.finish.bind(this), this);
            },

            onFinish: function () {
                this.force && this.force.hideForceHints();

                Merge2.current.counter.trigger();
            }
        };

        return new TutorialStep(options);
    },

    createDelayStep: function (delay) {
        const options = {
            onStart: function () {
                cleverapps.timeouts.setTimeout(this.finish.bind(this), delay);
            },

            onFinish: function () {
                Merge2.current.counter.trigger();
            }
        };

        return new TutorialStep(options);
    },

    createDialogueStep: function (step) {
        return new TutorialStep({
            onStart: function () {
                const imageBundle = step.imageBundle;
                const config = step.dialogueConfig;

                const showDialogue = () => {
                    if (!cleverapps.focusManager.isFocused() || this.isFinished()) {
                        return;
                    }

                    if (!cleverapps.tutorial.hasFocus()) {
                        cleverapps.focusManager.once("changeFocus", () => setTimeout(showDialogue, 0), this);
                        return;
                    }

                    const dialogueData = config.getJson();

                    const dialogue = new Dialogue(dialogueData, {
                        imageBundle,
                        autoClose: true,
                        autoScroll: false,
                        showUp: true
                    });

                    dialogue.on("afterClose", () => this.finish(), this);

                    new DialogueView(dialogue);
                };

                cleverapps.bundleLoader.loadBundle(config.bundleName, {
                    onSuccess: showDialogue
                });
            },

            onFinish: function () {
                Merge2.current.counter.trigger();
            }
        });
    },

    createUnitsLibraryStep: function (step) {
        const options = {
            onStart: function () {
                cleverapps.focusManager.showControlsWhileFocused(Merge2.current.getUpContainerControls());
                cleverapps.focusManager.showControlsWhileFocused(["unitInfoView"]);
                const unitInfoView = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).unitInfoView;

                const infoButton = ComponentUtils.findChildByName(unitInfoView, "infoButton");

                this.force = Merge2TutorialHelper.createForce(infoButton, {
                    text: step.text
                }, {
                    highlights: [unitInfoView],
                    importantNodes: [unitInfoView]
                });

                cleverapps.tutorial.on("infoview_help_button_clicked", this.finish.bind(this), this);
            },

            onFinish: function () {
                this.force.hideForceHints();
                Merge2.current.counter.trigger();
            }
        };

        return new TutorialStep(options);
    },

    findOfferRowView: function (id) {
        return cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).ordersTable.getRowView(id);
    },

    createForce: function (element, force, options) {
        let createdForce;
        cleverapps.focusManager.display({
            focus: "TutorialForce",
            stack: true,
            keepControls: true,
            action: (f) => {
                createdForce = cleverapps.forces.create(element, force, options);
                Merge2TutorialHelper.highlightSelection(createdForce);
                cleverapps.forces.onceForceClosed = f;
            }
        });
        return createdForce;
    },

    highlightSelection: function (force) {
        const field = Merge2.current.field;
        const selection = field.getMapView().selection;
        const updateSelection = (unit, isDragging) => {
            const highlighted = !isDragging && unit && force.highlights.includes(unit.onGetView());
            const index = force.highlights.indexOf(selection);
            if (highlighted && index === -1) {
                force.highlights.push(selection);
                if (force.forceConfig.shadow !== false) {
                    selection._setGlobalZOrder(true);
                }
            } else if (!highlighted && index !== -1) {
                selection._setGlobalZOrder(false);
                force.highlights.splice(index, 1);
            }
        };
        updateSelection(field.selectedUnit, Boolean(field.dragging));
        field.on("unitSelectionChanged", updateSelection, force);
    }
};

cleverapps.styles.Merge2TutorialHelper = {
    PositionAboveMap: {
        topOffset: 50
    }
};